module.exports = __webpack_public_path__ + "static/media/32a2c5cf-6736-44a6-a276-49ba7e030944.26d6ef19.woff2";